import { UserManager, WebStorageStateStore } from "oidc-client-ts";

const OIDC_AUTHORITY = process.env.OIDC_AUTHORITY || "";
const OIDC_CLIENT_ID = process.env.OIDC_CLIENT_ID || "";
const OIDC_REDIRECT_URI = process.env.OIDC_REDIRECT_URI || "";
const OIDC_POST_LOGOUT_REDIRECT_URI = process.env.OIDC_POST_LOGOUT_REDIRECT_URI || "";

export const OIDC_ENABLED = !!OIDC_AUTHORITY && !!OIDC_CLIENT_ID;

export const userManager = OIDC_ENABLED
  ? new UserManager({
      authority: OIDC_AUTHORITY,
      client_id: OIDC_CLIENT_ID,
      redirect_uri: OIDC_REDIRECT_URI,
      post_logout_redirect_uri: OIDC_POST_LOGOUT_REDIRECT_URI,
      response_type: "code",
      scope: "openid profile email offline_access",
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      automaticSilentRenew: true,
      accessTokenExpiringNotificationTimeInSeconds: 60,
    })
  : null;

export function getOIDCAccessToken(): string | null {
  if (!OIDC_ENABLED) return null;
  const key = `oidc.user:${OIDC_AUTHORITY}:${OIDC_CLIENT_ID}`;
  const raw = localStorage.getItem(key);
  if (!raw) return null;
  try {
    return JSON.parse(raw).access_token ?? null;
  } catch {
    return null;
  }
}
